import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-n fac fjb servicelist-tab" }
const _hoisted_2 = { class: "list-content" }
const _hoisted_3 = {
  class: "flex-content mt-20",
  style: {"padding-top":"1rem"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "price" }

import ItemContent from "@/components/ItemContent/ItemContent.vue";
import {onMounted, ref, nextTick,watch} from "vue";
import {useRouter, useRoute} from 'vue-router'
import weChatApi from "@/utils/Api/WeChat";
import TabContent from "@/components/TabContent/TabContent.vue";
import serviceItemCategoryApi from "@/utils/ServiceItemCategory";

export default /*@__PURE__*/_defineComponent({
  __name: 'servicelist',
  setup(__props) {


const chooseTab:any=ref();
const router = useRouter();
const route = useRoute();
// const menuList=[{
//   label:'墓园',
//   value:3
// },{
//   label:'殡仪公司',
//   value:2
// },{
//   label:'殡仪馆',
//   value:4
// }]

onMounted(() => {
  document.title = '产品列表';
  GetServiceItemCategoryList();
})
const refreshing = ref(false);
const list: any = ref([]);
const pageNo = ref(0);
const refresh = ref(false);
const loading = ref(false);
const finished = ref(false);
const onRefresh = () => {
  pageNo.value = 0;
  list.value = [];
  refreshing.value = false;
  // 清空列表数据
  finished.value = false;
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  onLoad();
};
const onLoad = () => {
  pageNo.value++;
  console.log(pageNo.value)
  weChatApi.getServiceItemPage(pageNo.value, {merchantMemberId: route.query.id,categoryid:chooseTab.value}).then(res => {
    console.log(res)
    list.value = list.value.concat(res.data.data || []);
    if (list.value.length >= res.data.dataCount) {
      finished.value = true;
    }
  }).finally(() => {
    loading.value = false;
    refresh.value = false;
  })
};


const gotoPage = (id: string) => {
  router.push('/servicedetail?id=' + id)
}
watch(()=>chooseTab.value,(newval)=>{
  onRefresh();
})
const menuList:any=ref([]);
const GetServiceItemCategoryList=()=>{
  serviceItemCategoryApi.noPageList().then(res=>{
    console.log('品相分类',res)
    let list=[];
    for(let i=0;i<res.data.length;i++){
      if(i==0){
        chooseTab.value=res.data[i].id;
      }
      list.push({
        label:res.data[i].categoryname,
        value:res.data[i].id
      })
    }
    menuList.value=list;
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TabContent, {
        modelValue: chooseTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chooseTab).value = $event)),
        list: menuList.value
      }, null, 8, ["modelValue", "list"])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"height":"4.5rem"} }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
            finished: finished.value,
            "finished-text": "没有更多了",
            "immediate-check": false,
            onLoad: onLoad
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item",
                    onClick: ($event: any) => (gotoPage(item.id)),
                    key: item.id
                  }, [
                    _createElementVNode("img", {
                      src: item.itemCoverImg
                    }, null, 8, _hoisted_5),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.itemname), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text" }, "所属分类", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", null, "￥", -1)),
                      _createTextVNode(_toDisplayString(item.itemprice), 1)
                    ])
                  ], 8, _hoisted_4))
                }), 128)),
                _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"width":"100%","height":"1rem"} }, null, -1))
              ])
            ]),
            _: 1
          }, 8, ["loading", "finished"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})